import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { courseMembershipOptions } from '@/module/Nomen/CourseMembership/model/CourseMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type CourseMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function CourseMembershipSelectControl<T extends FieldValues>(props: CourseMembershipSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(courseMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
